import BladeTextContainer from './BladeTextGatsbyCDAContainer.js'
import BladeTextApolloCPAContainer from './BladeTextApolloCPAContainer.js'
export default BladeTextContainer
export {
  BladeTextContainer as BladeTextGatsbyCDAContainer,
  BladeTextApolloCPAContainer,
}
